//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import Slick from 'vue-slick';
import arrowLeft from 'images/arrow_left.png';
import arrowRight from 'images/arrow_right.png';

export default {
  props: {
    title: String,
  },
  data: function() {
    return {
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      numberOfSlides: 0,
      arrowLeft,
      arrowRight,
    };
  },
  components: {
    slick: Slick,
  },
  methods: {
    prev: function() {
      this.$refs.slick.prev();
    },
    next: function() {
      this.$refs.slick.next();
    },
    handleInit: function(event, slick) {
      this.numberOfSlides = slick.$slides.length;
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/recent-news-carousel/RecentNewsCarousel.vue